import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, FormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, Router, TitleStrategy } from '@angular/router';
import { AnyCatcher } from 'rxjs/internal/AnyCatcher';
import { Depto } from 'src/app/model/depto';
import { Muni } from 'src/app/model/muni';
import { PedidoTemp } from 'src/app/model/pedidoTemp';
import { TokenStorageServiceCliente } from 'src/app/services/api/TokenStorageServiceCliente';
import { DeptoService } from 'src/app/services/api/depto.service';
import { MuniService } from 'src/app/services/api/muni.service';
import { PedidoService } from 'src/app/services/api/pedido.service';
import { db } from 'src/app/services/bd/bd';
import { environment } from 'src/environments/environment';
import { CambioService } from 'src/app/services/api/cambio.service';
import { TransacNeo } from 'src/app/model/transacNeo';
import { NeoLinkService } from 'src/app/services/api/neoLink.service';
import { ProductoDTOService } from 'src/app/services/api/productoDTO.service';
import { ResultadoVerificacion } from 'src/app/model/resultadoVerificacion';
import { Shopping } from 'src/app/model/shopping';
import { StockERPService } from 'src/app/services/api/stockERP.service';
import { ProductosDTO } from 'src/app/model/productosDTO';
import { CredencialesNeoNet } from 'src/app/model/credencialNeoNet';
import { PedidoDTOService } from 'src/app/services/api/pedidoDTO.service';
import { CodigoDescuento } from 'src/app/model/codigoDescuento';
import { Observable } from 'rxjs';
import { HostListener } from '@angular/core';
declare let $: any;

@Component({
  
  selector: 'app-carrito',
  templateUrl: './carrito.component.html',
  styleUrls: ['./carrito.component.css'],

  
}




)
export class CarritoComponent implements OnInit {

  @HostListener('window:scroll', [])
  onWindowScroll() {
   if (
     document.body.scrollTop > 100 ||
     document.documentElement.scrollTop > 100
   ) {
     document.getElementById('appear')?.classList.add('active')
   }
   else(
     document.getElementById('appear')?.classList.remove('active')
   )
 }
 title = 'WhatsApp';



  @ViewChild('myModal')myModal!: ElementRef;
  @ViewChild('myModal2')myModal2!: ElementRef;
  @ViewChild('myModalError')myModalError!: ElementRef;
  formCarrito!: FormGroup;
pedidoTemp:PedidoTemp[]=[];
pedidoTempDescuento:PedidoTemp[]=[];
ipPublicaDTO:string="";
shopping:Shopping[]=[];
credencialesNeoNet:CredencialesNeoNet[]=[];
resultadoVerificacion:ResultadoVerificacion[]=[];
subTotal:number=0;
granTotalDTO:number=0;
totalDTO:number=0;
descuentoDTO:number=0;
CantidadItem:string="0";
activeTab: string | undefined;
tabIndex:number=0;
idClienteDTO:Number=0;
idUsrDTO:number=0;
esperar = true;
displayStyle: any;
displayStyle2:boolean=false;
numeroPedido:String="0";
urlServerUpload$ : string = `${environment.HOST}/api/media/`;
tempdetallepedido:String="";
i:number=0;
display:any;
errorForm:String[]=["0","0","0","0",'0','0'];
errorForm2:String[]=["0","0","0","0"];
depto:Depto[]=[];
muni:Muni[]=[];
tipoMedia$ : String = "/0";
idFormaPago:number=1;
value = '';
modoPedido?:number=0;
activaPago:number=0;
nuevoPrecio:number=0;
idPedidoDTO:number=0;
indiceDetallePedidoDTO:number=0;
colorERP:String="";
colorIdErp:number=0;
transacNeo?:TransacNeo;
authResponseDTO?:string="";
responseDTO?:string="";
retrievalResponseDTO?:string="0";
noTarjetaDTO?:string="0";
sysTraceNo?:string ="0";
fechaPedidoDTO?:Date;
horaPedidoDTO?:String;
rsNeoNet?:string="";
respuestaModal?:boolean=false ;
confirmarCambio?:boolean=false ;
respuestaModalTarjeta?:boolean=false ;
TotalExistenciaERP:number=0;
msjTiempoEtrega?:String;
mensajeForm?:string;
formBuscar!: FormGroup;
modoBusqueda:boolean=false;
countpedido:string="0";
nombreCuenta:String="Mi cuenta";
tieneSession:boolean=false ;
productosdto:ProductosDTO[]=[];
merchantUserDTO:string="";
merchantPasswordDTO:string="";
afiliacionNeoNetDTO:string="";
terminalNeoNetDTO:string="";
nombreEmpresaDTO:string="";
nombreTarjetaDTO:string="";
direccionEmpresaDTO:string="";
tipoMedia2$ : String = "/0";
cardTypeDTO:String="";
tarjetaInvalida:boolean=false ;
fechaTarjetaInvalida:boolean=false ;
urlServerUploadArticulos$ : string = `${environment.HOST}/api/media/`;
@ViewChild("mycmbDepto") mycmbDepto!: ElementRef;
@ViewChild("mytxtTarjeta") mytxtTarjeta!: ElementRef;
content:any = [];
currentPage:number=0;
totalPages:number=0;
page = 0;
size = 6;
order = 'descripcion';
asc = true;
timeLocalTransDTO:string="";
dateLocalTransDTO:string="";
ocultarCarrito:boolean=false;
formaPagoDTO:Number=0;
cuotaDTO:String="";
codigoDescuentos:CodigoDescuento[]=[];
noExisteCodigoDescuento:boolean=false;
SIExistenCodigoDescuento:boolean=false;
idCodigoDescuentoDTO:number=0;
hayDescuentoPrecio:boolean=false;
constructor(
  private router:Router,
  private tokenStorage: TokenStorageServiceCliente,
  private pedidoService:PedidoService,
  private pedidoDTOService:PedidoDTOService,
  private cambioService:CambioService,
  private deptoService:DeptoService,
  private muniService:MuniService,
  private activatedRoute : ActivatedRoute,
  private neoLinkService:NeoLinkService,
  private productoDTOService : ProductoDTOService,
  private stockERPService:StockERPService,
  
){
 
}



ngOnInit():void {


  this.formCarrito = new FormGroup({
    'txtRecibe' : new FormControl('', Validators.required),
    'txtDireccion' : new FormControl('', Validators.required),
    'txtTelefono' : new FormControl('', Validators.required),
    'cmbDepto' : new FormControl('', Validators.required),
    'cmbMuni' : new FormControl('', Validators.required),
    'cmbFormaPago' : new FormControl('', Validators.required),
    'cmbCuotas' : new FormControl('', Validators.required),
    'txtTarjeta' : new FormControl(''  , Validators.required),
    'txtVencimiento' : new FormControl('', Validators.required),
    'txtCodigoSeguridad' : new FormControl('', Validators.required),
    'txtNit' : new FormControl('', Validators.required),
    'txtNombreContribuyente' : new FormControl('', Validators.required),
    'txtDireccionContribuyente' : new FormControl('', Validators.required),
    'txtMotivo' : new FormControl('', Validators.required),
    'txtTelFactura' : new FormControl('', Validators.required),
    'txtNombreTarjeta' : new FormControl('', Validators.required),
    'txtCodigoDescuento' : new FormControl('', Validators.required)
  });

 

  this.formBuscar = new FormGroup({
    'txtBuscar' : new FormControl('', Validators.required),
  });

  
this.OnGetIPPublica();
this.OnGetCredencialNeoNet();
this.OnContarPedido();
this.OnGetCodigoDescuentoAll();



this.modoPedido = Number(localStorage.getItem('modo_pedido_ls'));




if (localStorage.getItem('codigoDescuentoId') !== null){
  this.idCodigoDescuentoDTO=Number(localStorage.getItem('codigoDescuentoId'));

}else {
  this.idCodigoDescuentoDTO=0;
}


  this.onGetDepto();
  
  this.MostrarDetalle();


  if (this.tokenStorage.getToken()!==null) {
    let json = JSON.stringify(this.tokenStorage.getUser());
    let data=JSON.parse(json.toString());
    this.idUsrDTO=data.idUsuario;
    this.nombreCuenta=data.nombre
    this.tieneSession=true ;
      }
this.formCarrito.controls['cmbFormaPago'].setValue(1);

this.formCarrito.controls['cmbCuotas'].setValue("00")





if (this.modoPedido==1){


  if (Number(this.granTotalDTO)>0){

this.activaPago=1;
  }else {
    this.activaPago=0;
  }

}


if (this.modoPedido==0){
  this.activaPago=1;
}

if (localStorage.getItem('shopping')){

  let datoShopping=JSON.stringify(localStorage.getItem('shopping'));
  this.shopping=JSON.parse(datoShopping);
  this.shopping=JSON.parse(localStorage.getItem('shopping')+"");
  
  for (let lista of this.shopping){
  console.log(lista.recibe);
  this.formCarrito.controls['cmbDepto'].setValue(lista.depto);
  this.onGetMuni();
  this.formCarrito.controls['cmbMuni'].setValue(lista.muni);
  this.formCarrito.controls['txtRecibe'].setValue(lista.recibe);
  this.formCarrito.controls['txtDireccion'].setValue(lista.direccion);
  this.formCarrito.controls['txtTelefono'].setValue(lista.telefono);
  this.formCarrito.controls['cmbFormaPago'].setValue(lista.formaPago);
  this.formCarrito.controls['txtTarjeta'].setValue(lista.tarjeta);
  this.formCarrito.controls['txtNit'].setValue(lista.nit);
  this.formCarrito.controls['txtNombreContribuyente'].setValue(lista.nombreFactura);
  this.formCarrito.controls['txtDireccionContribuyente'].setValue(lista.direccionFactura);
  this.formCarrito.controls['txtTelFactura'].setValue(lista.telefonoFactura);
  this.formCarrito.controls['txtVencimiento'].setValue(lista.vencimiento);
  this.formCarrito.controls['txtCodigoSeguridad'].setValue(lista.cvv);
  this.formCarrito.controls['txtNombreTarjeta'].setValue(lista.nombreTarjeta);
  this.formCarrito.controls['cmbCuotas'].setValue(lista.cuotas);
  

  }
  



}


this.idFormaPago=parseInt(this.formCarrito.value['cmbFormaPago']);

if (this.idFormaPago==2){


}


//localStorage.setItem('shopping','');




if (localStorage.getItem('ejecutaCompra')=='1'){
localStorage.setItem('ejecutaCompra','0');
  this.OnCargarDetalle().then(data => {
    this.pedidoTemp = data;
    this.GenerarPedido();
  });

 }



 window.scroll({ top: 0, left: 0, behavior: 'smooth' });


}

OnGetIPPublica(){

  fetch('https://api.ipify.org?format=json')
  .then(response => response.json())
  .then(data => this.ipPublicaDTO=data.ip)
  .catch(error => this.ipPublicaDTO="0.0.0.0.");

  //console.log(this.ipPublicaDTO);

}

OnHabilitarBusqueda(){
  this.ocultarCarrito=true;
}

OnCerrarBusqueda(){
  this.ocultarCarrito=false;
}



onGetDepto(){

  this.deptoService.getDepto( ).subscribe(response =>{
    console.log(response)
    return this.depto=response
  })

}

onGetMuni(){



  this.muniService.getMuni(this.formCarrito.value['cmbDepto'] ).subscribe(response =>{
    console.log(response)
    return this.muni=response
  })

}





BorrarTodo(){
  
  this.LimparBD();
this.MostrarDetalle();
localStorage.setItem('countPedido', "0");
localStorage.removeItem('cliente_stg');
this.CantidadItem=localStorage.getItem('countPedido')+"";
this.tokenStorage.signOut();
this.router.navigateByUrl('/inicio');


}

MostrarDetalle(){
 
  

  this.OnCargarDetalle().then(data => {
    this.pedidoTemp = data;
    this.granTotalDTO=0;
    this.tempdetallepedido="";
    this.totalDTO=0;
    
   this.i=0;


   for (let lista of this.pedidoTemp){

   this.totalDTO=Number(this.totalDTO) + Number(lista.precio+"");
   this.descuentoDTO=Number(this.descuentoDTO) + (Number(lista.precio)-Number(lista.precioFinal));
   this.granTotalDTO=Number(this.granTotalDTO) + Number(lista.precioFinal+"");
  
 
   this.idPedidoDTO=Number(lista.idPedido);
   this.indiceDetallePedidoDTO=Number(lista.indiceDetallePedido);
   this.colorERP=lista.colorErp+"";
   this.colorIdErp=Number(lista.colorIdErp);
 

   if (  this.descuentoDTO>0){
this.hayDescuentoPrecio=true;
   }
   


   const listatemp: PedidoTemp= {
    indiceDetallePedido:this.indiceDetallePedidoDTO,
    idPedido:this.idPedidoDTO,
    idProducto:lista.idProducto,
    modelo:lista.modelo,
    descripcion:lista.descripcion,
    color:lista.color,
    talla:lista.talla,
    cantidad:lista.cantidad,
    precio:lista.precio,
    descuento:lista.descuento,
    precioFinal:lista.precioFinal,
    importe:lista.importe,
    imagen:lista.imagen,
    idColor:lista.idColor,
    idTalla:lista.idTalla,
    idProductoAnterior:lista.idProductoAnterior,
    colorErp:lista.colorErp,
    colorIdErp:lista.colorIdErp,
    codigoErp:lista.codigoErp,
    limitarExistencia:lista.limitarExistencia,
  }





this.OnGetStockERP(lista);






  let json = JSON.stringify(listatemp);
  this.i++;

  if (this.i==1){ 
    this.tempdetallepedido=this.tempdetallepedido+json.replace('#','');;
  }
  if (this.i>1){ 
    this.tempdetallepedido=this.tempdetallepedido+',,'+json.replace('#','');;
  }




   }
  



 
  });




}



async AgregarACarrito(datos:any) {

  await db.detallePedidoBD.add(datos);

 
}

OnGetCredencialNeoNet(){
  this.pedidoService.getCredencialNeoNet().subscribe(response =>{

 //this.credencialesNeoNet=response;
  

 for(let dato of response) {
  this.afiliacionNeoNetDTO=(dato.afiliacion+"");
  this.terminalNeoNetDTO=(dato.terminal+"");
  this.merchantPasswordDTO=(dato.merchantpassword+"");
  this.merchantUserDTO=(dato.merchantuser+"");
  this.nombreEmpresaDTO=(dato.nombreEmpresa+"");
  this.direccionEmpresaDTO=(dato.direccion+"");
 }



  });



}


OnGetStockERP(_datos:PedidoTemp){

 
this.stockERPService.getStockERP(_datos.codigoErp).subscribe(response =>{
  

  
  if (response.length>0){

  

      const listatemp2: PedidoTemp= {
        id:_datos.id,
        indiceDetallePedido:_datos.indiceDetallePedido,
        idPedido:_datos.idPedido,
        idProducto:_datos.idProducto,
        modelo:_datos.modelo,
        descripcion:_datos.descripcion,
        color:_datos.color,
        talla:_datos.talla,
        cantidad:_datos.cantidad,
        precio:_datos.precio,
        descuento:_datos.descuento,
        precioFinal:_datos.precioFinal,
        importe:_datos.importe,
        imagen:_datos.imagen,
        idColor:_datos.idColor,
        idTalla:_datos.idTalla,
        idProductoAnterior:_datos.idProductoAnterior,
        colorErp:_datos.colorErp,
        colorIdErp:_datos.colorIdErp,
        codigoErp:_datos.codigoErp,
        limitarExistencia:_datos.limitarExistencia,
        msgDisponibilidad:"Tiempo de entrega:  2-3 días",
        tipoDespacho:"1"
      }
      
     
      

      this.ModificarDeCarrito(listatemp2);
      this.OnCargarDetalle().then(data => {
      this.pedidoTemp = data;
      });

    

     }else {
     
      let fechaActual = new Date();
      let msj;
      const fechaComoCadena = fechaActual.getFullYear()+"-"+fechaActual.getMonth()+"-"+fechaActual.getDate()+ " 23:59:00"; // día lunes
    
      const dias = [
        'domingo',
        'lunes',
        'martes',
        'miércoles',
        'jueves',
        'viernes',
        'sábado'
      ];
      const numeroDia = new Date(fechaComoCadena).getDay();
      const nombreDia = dias[numeroDia];
     // console.log("Nombre de día de la semana: ", fechaActual.getDate());
    
    if (nombreDia=='domingo'){
      msj="Tiempo de entrega: 11 días aprox.";
  
    }
    
    if (nombreDia=='lunes'){
      msj="Tiempo de entrega: 10 días aprox.";
    }
    
    if (nombreDia=='martes'){
      msj="Tiempo de entrega: 9 días aprox.";
    }
    
    if (nombreDia=='miércoles'){
      msj="Tiempo de entrega: 8 días aprox.";
    }
    
    if (nombreDia=='jueves'){
      msj="Tiempo de entrega: 7 días aprox.";
    }
    
    if (nombreDia=='viernes'){
      msj="Tiempo de entrega: 13 días aprox.";
    }
    
     if (nombreDia=='sábado'){
       msj="Tiempo de entrega: 12 días aprox.";
     }


     const listatemp2: PedidoTemp= {
       id:_datos.id,
       indiceDetallePedido:_datos.indiceDetallePedido,
       idPedido:_datos.idPedido,
       idProducto:_datos.idProducto,
       modelo:_datos.modelo,
       descripcion:_datos.descripcion,
       color:_datos.color,
       talla:_datos.talla,
       cantidad:_datos.cantidad,
       precio:_datos.precio,
       descuento:_datos.descuento,
       precioFinal:_datos.precioFinal,
       importe:_datos.importe,
       imagen:_datos.imagen,
       idColor:_datos.idColor,
       idTalla:_datos.idTalla,
       idProductoAnterior:_datos.idProductoAnterior,
       colorErp:_datos.colorErp,
       colorIdErp:_datos.colorIdErp,
       codigoErp:_datos.codigoErp,
       limitarExistencia:_datos.limitarExistencia,
     msgDisponibilidad:msj,
     tipoDespacho:"2"
    
    
     }


     this.ModificarDeCarrito(listatemp2);
     this.OnCargarDetalle().then(data => {
     this.pedidoTemp = data;
     });



    
  }

});





}



OnGuardarStockTemporal(codigoErp:any,stock:any){
  this.productoDTOService.guardaStockTemporal(codigoErp,stock).subscribe(response =>{
    console.log(response)
  
  })
}




async ModificarDeCarrito(datos:any) {
  await db.detallePedidoBD.put(datos);
}







irAtras(){
 
   window.history.back();
  

}


OnContinuar(){

  this.LimparBD();

 $(this.myModal.nativeElement).modal('hide'); 

   localStorage.removeItem('shopping');
this.router.navigate(['/inicio']);
//this.logout();

}
 



IraInicio(){

  //$(this.myModal.nativeElement).modal('show') ;

 //this.router.navigate(['/inicio']);
 
 this.router.navigate(['/inicio'])
 .then(() => {
   window.location.reload();
 });





}


CerrarModal2(){

  $(this.myModal2.nativeElement).modal('hide'); 

}



async EliminarDeCarrito(id:any) {

await db.detallePedidoBD.where('id').equals(id).delete();
this.MostrarDetalle();


this.OnContarPedido();

  if (localStorage.getItem('countPedido') !== null){
    this.countpedido=localStorage.getItem('countPedido')+"";
  }else {
    this.countpedido="0";
  }
  
  localStorage.setItem('modo_pedido_ls','0');

}





async OnCargarDetalle() {
return await db.detallePedidoBD.toArray();
}



async OnById() {
  return await db.detallePedidoBD
    .where('id').equals(7)
    .toArray();
  }



  OnContarPedido(){
 
    this.ContarRegistros().then(data => {
      this.CantidadItem=data+"";

  
    });
   
  }
  
  async ContarRegistros() {
    return await db.detallePedidoBD.count();
    }

  
  async LimparBD() {

    return await db.detallePedidoBD.clear();
    
    }


    tabAvanzar( $event: MouseEvent): void{
     
      if (this.tokenStorage.getToken()==null) {
    
        // this.roles = this.tokenStorage.getUser();
         this.router.navigateByUrl('/login-cliente');
       }else {

         
      $event.preventDefault();

      switch (this.tabIndex){

        case 0:
          this.activeTab = 'custom-tabs-four-carrito';
          this.tabIndex++
          break;
          case 1:

          this.activeTab = 'pago';

          break;
      }


       }
   
     
    

     

     

    }



    ValidarNuevoRegistro3(){
      let rs:number=0;
      let rs1:number=0;
      let rs2:number=0;
      let rs3:number=0;
      let rs4:number=0;
      let input1:string=this.formCarrito.value['txtNit'];
      let input2:string=this.formCarrito.value['txtNombreContribuyente'];
      let input3:string=this.formCarrito.value['txtDireccionContribuyente'];
      let input4:string=this.formCarrito.value['txtTelFactura'];
      if (input1.length>1){
        this.errorForm2[3]="0";
        rs1= 0;
      }else {
        this.errorForm2[3]="1";
        rs1= 1;
      }

      if (input2.length>4){
        this.errorForm2[4]="0";
        rs2= 0;
      }else {
        this.errorForm2[4]="1";
        rs2= 1;
      }
   
      if (input3.length>4){
        this.errorForm2[5]="0";
        rs3= 0;
      }else {
        this.errorForm2[5]="1";
        rs3= 1;
      }
    
      
    
      if (input4.length>7){
        this.errorForm2[6]="0";
        rs4= 0;
      }else {
        this.errorForm2[6]="1";
        rs4= 1;
      }
    
    
      rs=rs1+rs2+rs3+rs4;
    
      
    
    
    
    return rs;



    }



    ValidarNuevoRegistro2(){
      let rs:number=0;
      let rs1:number=0;
      let rs2:number=0;
      let rs3:number=0;
      let rs4:number=0;
      let rs5:number=0;
      let rs6:number=0;
      let rs7:number=0;
      let rs8:number=0;
     let input1:string=this.formCarrito.value['txtTarjeta'];
     let input2:string=this.formCarrito.value['txtVencimiento'];
     let input3:string=this.formCarrito.value['txtCodigoSeguridad'];
     let input4:string=this.formCarrito.value['txtNit'];
     let input5:string=this.formCarrito.value['txtNombreContribuyente'];
     let input6:string=this.formCarrito.value['txtDireccionContribuyente'];
     let input7:string=this.formCarrito.value['txtTelFactura'];
     let input8:string=this.formCarrito.value['txtNombreTarjeta'];
        if (input1.length ==16  ) {

          

          this.errorForm2[0]="0";
            rs1= 0;


        }else {
          this.errorForm2[0]="1";
          rs1= 1;
        }
      
      
        if (input2.length==4){
          this.errorForm2[1]="0";
          rs2= 0;
        }else {
          this.errorForm2[1]="1";
          rs2= 1;
        }
      
        if (input3.length==3 ||input3.length==3){
          this.errorForm2[2]="0";
          rs3= 0;
        }else {
          this.errorForm2[2]="1";
          rs3= 1;
        }

        if (input4.length>1){
          this.errorForm2[3]="0";
          rs4= 0;
        }else {
          this.errorForm2[3]="1";
          rs4= 1;
        }

        if (input5.length>4){
          this.errorForm2[4]="0";
          rs5= 0;
        }else {
          this.errorForm2[4]="1";
          rs5= 1;
        }
     
        if (input6.length>4){
          this.errorForm2[5]="0";
          rs6= 0;
        }else {
          this.errorForm2[5]="1";
          rs6= 1;
        }
      
        if (input7.length>7){
          this.errorForm2[6]="0";
          rs7= 0;
        }else {
          this.errorForm2[6]="1";
          rs7= 1;
        }
      
        if (input8.length>4){
          this.errorForm2[7]="0";
          rs8= 0;
        }else {
          this.errorForm2[7]="1";
          rs8= 1;
        }
      
      
        rs=rs1+rs2+rs3+rs4+rs5+rs6+rs7+rs8;
      
        
      
      
      
      return rs;
      }



      ValidarNuevoCambio(){
        let rs:number=0;
        let rs1:number=0;
        let rs2:number=0;
        let rs3:number=0;
        let rs4:number=0;
        let rs5:number=0;
        let rs6:number=0;
        
          if ( this.formCarrito.value['cmbDepto']>0){
            this.errorForm[0]="0";
            rs1= 0;
          }else {
            this.errorForm[0]="1";
            rs1= 1;
          }
        
        
          if (this.formCarrito.value['cmbMuni']>0){
            this.errorForm[1]="0";
            rs2= 0;
          }else {
            this.errorForm[1]="1";
            rs2= 1;
          }
        
          if (this.formCarrito.value['txtRecibe']!==""){
            this.errorForm[2]="0";
            rs3= 0;
          }else {
            this.errorForm[2]="1";
            rs3= 1;
          }
  
  
          
          if (this.formCarrito.value['txtDireccion']!==""){
            this.errorForm[3]="0";
            rs4= 0;
          }else {
            this.errorForm[3]="1";
            rs4= 1;
          }
        
        
          if (this.formCarrito.value['txtTelefono']!==""){
            this.errorForm[4]="0";
            rs5= 0;
          }else {
            this.errorForm[4]="1";
            rs5= 1;
          }


          if (this.formCarrito.value['txtMotivo']!==""){
            this.errorForm[5]="0";
            rs6= 0;
          }else {
            this.errorForm[5]="1";
            rs6= 1;
          }
        
        
          
        
        
        
        
          rs=rs1+rs2+rs3+rs4+rs5;
        
          
        
        
        
        return rs;
        }








    ValidarNuevoRegistro(){
      let rs:number=0;
      let rs1:number=0;
      let rs2:number=0;
      let rs3:number=0;
      let rs4:number=0;
      let rs5:number=0;
      let rs6:number=0;
      
        if ( this.formCarrito.value['cmbDepto']>0){
          this.errorForm[0]="0";
          rs1= 0;
        }else {
          this.errorForm[0]="1";
          rs1= 1;
        }
      
      
        if (this.formCarrito.value['cmbMuni']>0){
          this.errorForm[1]="0";
          rs2= 0;
        }else {
          this.errorForm[1]="1";
          rs2= 1;
        }
      
        if (this.formCarrito.value['txtRecibe']!==""){
          this.errorForm[2]="0";
          rs3= 0;
        }else {
          this.errorForm[2]="1";
          rs3= 1;
        }


        
        if (this.formCarrito.value['txtDireccion']!==""){
          this.errorForm[3]="0";
          rs4= 0;
        }else {
          this.errorForm[3]="1";
          rs4= 1;
        }
      
      
      
       
        if (this.pedidoTemp !== null ){
          this.errorForm[6]="0";
          rs6= 0;
        }else {
          this.errorForm[6]="1";
          rs6= 1;
        }
      
      
      
      
        rs=rs1+rs2+rs3+rs4+rs5+rs6;
      
        
      
      
      
      return rs;
      }


GuardarCambio(){


  this.esperar=true;
  this.cambioService.nuevoCambio(
  this.idUsrDTO,
  this.formCarrito.value['cmbDepto'],
  this.formCarrito.value['cmbMuni'],
  this.granTotalDTO,
  this.formCarrito.value['txtRecibe'].toString().toUpperCase() ,
  this.formCarrito.value['txtDireccion'].toString().toUpperCase(),
  this.formCarrito.value['txtTelefono'],
  this.formCarrito.value['txtMotivo'],
  this.formCarrito.value['cmbFormaPago'],
  this.tempdetallepedido,
  this.formCarrito.value['txtTarjeta'],
  "NULO",
  "NULO",
  this.formCarrito.value['txtNit'].toString().toUpperCase(),
  this.formCarrito.value['txtNombreContribuyente'].toString().toUpperCase(),
  this.formCarrito.value['txtDireccionContribuyente'].toString().toUpperCase()).subscribe(response =>{
    console.log(response)
 
   
    if (response.toString()!=="0"){
     

      this.numeroPedido=response.toString();
      this.LimparBD();
     
      localStorage.setItem('countPedido', "0");
      localStorage.setItem('modo_pedido_ls', "0");
      this.esperar=false;
      this.confirmarCambio=true ;
      this.mensajeForm="Gracias por utilizar esta plataforma, hemos recibido tu cambio!!!";
      $(this.myModal.nativeElement).modal('show'); 
    //  this.router.navigate(['/inicio']);

    }

    if (response.toString()=="0"){
      this.esperar=false;
     
     }
 
  
  })





}



GenerarPagoNeoLink(_tarjeta:string,_vencimiento:string,_cvv:string,_total:any,idPedido:any,_cuotas:any){
  this.esperar=true;
let _valorTotal=parseFloat(_total).toFixed(2);

  let _totalNeo=_valorTotal.toString().replace(".","");
  let _mes=_vencimiento.substring(0,2); 
  let _anio=_vencimiento.substring(2,4); 
  let _vencimientoNeo=_anio+_mes+"";



 
this.pedidoService.generarSystemTraceNo(  this.idUsrDTO).subscribe(response =>{
  console.log(response);
  let _rs=response;
  let _systemtraceno:any=0;
   _systemtraceno=this.zfill( Number(_rs),6);
  
console.log( _systemtraceno)


let tipoTarjeta=this.formCarrito.value['txtTarjeta'].substring(0,1);

if (tipoTarjeta=="2" || tipoTarjeta=="5") {
this.cardTypeDTO="002";
}else {

  if (tipoTarjeta=="4" ) {
    this.cardTypeDTO="001";
  }

}

  this.GenerarPagoNeoNet(_tarjeta,_vencimientoNeo,_cvv,_totalNeo,this.cardTypeDTO,_systemtraceno,_cuotas);
});









}


// EjecutarTransaccion(_tarjeta:String,_vencimientoNeo:String,_cvv:String,_totalNeo:String){

//       try {
        
       
     
//          this.GenerarPagoNeoNet(_tarjeta,_vencimientoNeo,_cvv,_totalNeo)+"";
         

//           if (localStorage.getItem('RespuestaNeoNet')!==null){
         

//             let dataNeo=JSON.parse(localStorage.getItem('RespuestaNeoNet')+"");
//             //console.log(dataNeo);
            
//             let responseCode;
//             let authResponse;
//             let retrievalReponse;
//             Object.keys(dataNeo).forEach(key => {
          
//               if (`${key}`=='ResponseCode'){
             
//                 responseCode=`${dataNeo[key]}`;
//               }

//               if (`${key}`=='KeyAuth'){
             
//                 authResponse=`${dataNeo[key]}`;
//               }

//               if (`${key}`=='KeyRetrieval'){
             
//                 retrievalReponse=`${dataNeo[key]}`;
//               }
          
            
//           });
          
          
            
           
//             if (responseCode!==null && responseCode=='00'){
//               this.OnGetDatosPagoPedido();
//               this.OnActualizarPagoTarjeta(this.numeroPedido,this.OnCambiarFormatoTajeta(_tarjeta),this.sysTraceNo,authResponse,retrievalReponse);
           
//                 this.esperar=false;
//                 this.respuestaModal=true ;
//               this.respuestaModalTarjeta=true ;
              
         
         
             
//               this.responseDTO=responseCode;
            
            
              

//             }else {
             
   
//               this.esperar=false;
//               this.mensajeForm="No fue posible terminar la transacción.";
//               $(this.myModal.nativeElement).modal('hide'); 
//               $(this.myModalError.nativeElement).modal('show'); 
//             }
           
            
         
        
        
        
//         }else {
//           this.esperar=false;
//           this.mensajeForm="No fue posible terminar la transacción.";
//           $(this.myModal.nativeElement).modal('hide'); 
//           $(this.myModalError.nativeElement).modal('show'); 
//         }


       
        
     
   

        

//       } catch (error) {
//         console.log(error);
        
//         this.esperar=false;
//         $(this.myModal.nativeElement).modal('hide'); 
//         $(this.myModalError.nativeElement).modal('show');  
//       }


    




// }


// OnActualizarPagoTarjeta(idPedido:any,tarjeta:any,systemtraceno:any,authresponse:any,retrievalresponse:any,nombreTarjeta:any){
//   this.pedidoService.actualizaPagoTarjeta(idPedido,tarjeta,systemtraceno,authresponse,retrievalresponse,this.granTotalDTO,nombreTarjeta).subscribe(response =>{
//     this.OnGetDatosPagoPedido();
//   });
// }


OnFormatoTimeLocalTrans(_dato:any){

  let hora=_dato.substring(0,2);
  let min=_dato.substring(2,4);
let nuevahora=hora+":"+min;

return nuevahora;


}


OnGetDatosPagoPedido(){
  this.pedidoService.getTransaccionElectronica(Number(this.numeroPedido)).subscribe(response =>{
console.log(response);

    
 for(let dato of response) {
  this.authResponseDTO=(dato.authIdResponse+"");
  this.retrievalResponseDTO=(dato.retrievalRefNo+"");
  this.sysTraceNo=(dato.systemTraceno+"");
  this.noTarjetaDTO=(dato.tarjeta+"");
  this.fechaPedidoDTO=(dato.fecha);
  this.horaPedidoDTO=dato.hora+"";
  this.nombreTarjetaDTO=dato.nombreTarjeta+"";
  this.dateLocalTransDTO=dato.fecha+"";
  this.timeLocalTransDTO=this.OnFormatoTimeLocalTrans(dato.timeLocalTrans+"");
  this.cuotaDTO=dato.cuota+"";

 }



  });

  
  this.LimparBD();
  localStorage.setItem('countPedido', "0");
  localStorage.removeItem('shopping');
}





// GenerarReversionNeoNet(_tarjeta:String,_vencimientoNeo:String,_cvv:String,_totalNeo:String,_cardType:String){


// let datos={
//   "MessageTypeId": "0400",
//   "ProcessingCode": "000000",
//   "SystemsTraceNo": this.sysTraceNo+"",
//   "TimeLocalTrans": "",
//   "DateLocalTrans": "",
//   "PosEntryMode": "012",
//   "Nii": "003",
//   "PosConditionCode": "00",
//   "AdditionalData": "",
//   "OrderInformation": "",
//   "FormatId": "1",
//   "Merchant": {
//     "TerminalId": this.terminalNeoNetDTO,
//     "CardAcqId": this.afiliacionNeoNetDTO
//   },
//   "Card": {
//     "Type":_cardType,
//     "PrimaryAcctNum":_tarjeta,
//     "DateExpiration": _vencimientoNeo,
//     "Cvv2": _cvv,
//     "Track2Data": "",
//     "CardTokenId": "",
//     "UniqueCodeofBeneciary": ""
//   },
//   "Amount": {
//     "AmountTrans": _totalNeo,
//     "AmountDiscount": "",
//     "RateDiscount": "",
//     "AdditionalAmounts": "",
//     "TaxDetail": [
//     ]
//   },
//   "PrivateUse60": {
//     "BatchNumber": ""
//   },
//   "PrivateUse63": {
//     "LodgingFolioNumber14": "",
//     "NationalCard25": "",
//     "HostReferenceData31": "",
//     "TaxAmount1": ""
//   },
//   "TokenManagement": {
//     "Type": "",
//     "ActionMethod": ""
//   },
//   "Customer": {
//     "CustomerTokenId": "",
//     "FirstName": "",
//     "LastName": "",
//     "TaxId": "",
//     "IdentificationType": "",
//     "PersonalId": "",
//     "Email": "",
//     "PhoneNumber": ""
//   },
//   "BillTo": {
//     "FirstName": "",
//     "LastName": "",
//     "Company": "",
//     "AddressOne": "",
//     "AddressTwo": "",
//     "Locality": "",
//     "AdministrativeArea": "",
//     "PostalCode": "",
//     "Country": "",
//     "Email": "",
//     "PhoneNumber": ""
//   },
//   "ShipTo": {
//     "DefaultSt": "",
//     "FirstName": "",
//     "LastName": "",
//     "Company": "",
//     "AddressOne": "",
//     "AddressTwo": "",
//     "Locality": "",
//     "AdministrativeArea": "",
//     "PostalCode": "",
//     "Country": "",
//     "Email": "",
//     "PhoneNumber": "",
//     "ShippingAddressTokenId": ""
//   },
//   "PaymentInstrument": {
//     "PaymentInstrumentTokenId": ""
//   },
//   "CustomerPaymentInstrument": {
//     "CustomerPaymentInstrumentTokenId": "",
//     "DefaultCpi": ""
//   },
//   "PayerAuthentication": {
//     "Step": "",
//     "UrlCommerce": "",
//     "ReferenceId": ""
//   }
// };



// let json = JSON.stringify(datos);
// let data=JSON.parse(json.toString());


// let responseCode:string="";

// this.neoLinkService.pagarNeoLink( data,this.merchantUserDTO,this.merchantPasswordDTO,this.ipPublicaDTO).subscribe(response =>{
//   console.log(response)
   

//  let jsonstring = JSON.stringify(response);
//  let dataNeo=JSON.parse(jsonstring+"");

//  let authResponse;
//  let retrievalReponse;

//  Object.keys(dataNeo).forEach(key => {

//  if (`${key}`=='ResponseCode'){

//    responseCode=`${dataNeo[key]}`;
//  }

//  if (`${key}`=='AuthIdResponse'){

//    authResponse=`${dataNeo[key]}`;
//  }

//  if (`${key}`=='RetrievalRefNo'){

//    retrievalReponse=`${dataNeo[key]}`;
//  }


// });



// if (responseCode!==null && responseCode=='00'){

// //this.OnActualizarPagoTarjeta(this.numeroPedido,this.OnCambiarFormatoTajeta(_tarjeta),this.sysTraceNo,authResponse,retrievalReponse);

// this.esperar=false;
// this.mensajeForm="No fue posible terminar la transacción.";
// $(this.myModal.nativeElement).modal('hide'); 
// $(this.myModalError.nativeElement).modal('show');

// // }else {


// // this.esperar=false;
// // this.mensajeForm="No fue posible terminar la transacción.";
// // $(this.myModal.nativeElement).modal('hide'); 
// // $(this.myModalError.nativeElement).modal('show');




//  }











// });


// }


GenerarPagoNeoNet(_tarjeta:String,_vencimientoNeo:String,_cvv:String,_totalNeo:String,_cardType:String,_systemtraceno:any,_cuotas:any){
let datos=null;
if (this.idFormaPago==1){
   datos={
    "MessageTypeId": "0200",
    "ProcessingCode": "000000",
    "SystemsTraceNo": _systemtraceno+"",
    "TimeLocalTrans": "",
    "DateLocalTrans": "",
    "PosEntryMode": "012",
    "Nii": "003",
    "PosConditionCode": "00",
    "AdditionalData": "",
    "OrderInformation": "",
    "FormatId": "1",
    "Merchant": {
      "TerminalId": this.terminalNeoNetDTO,
      "CardAcqId": this.afiliacionNeoNetDTO
    },
    "Card": {
      "Type": _cardType,
      "PrimaryAcctNum": _tarjeta,
      "DateExpiration":_vencimientoNeo,
      "Cvv2": _cvv,
      "Track2Data": "",
      "CardTokenId": "",
      "UniqueCodeofBeneciary": ""
    },
    "Amount": {
      "AmountTrans": _totalNeo,
      "AmountDiscount": "",
      "RateDiscount": "",
      "AdditionalAmounts": "",
      "TaxDetail": [
      ]
    },
    "PrivateUse60": {
      "BatchNumber": ""
    },
    "PrivateUse63": {
      "LodgingFolioNumber14": "",
      "NationalCard25": "",
      "HostReferenceData31": "",
      "TaxAmount1": ""
    },
    "TokenManagement": {
      "Type": "",
      "ActionMethod": ""
    },
    "Customer": {
      "CustomerTokenId": "",
      "FirstName": "",
      "LastName": "",
      "TaxId": "",
      "IdentificationType": "",
      "PersonalId": "",
      "Email": "",
      "PhoneNumber": ""
    },
    "BillTo": {
      "FirstName": "",
      "LastName": "",
      "Company": "",
      "AddressOne": "",
      "AddressTwo": "",
      "Locality": "",
      "AdministrativeArea": "",
      "PostalCode": "",
      "Country": "",
      "Email": "",
      "PhoneNumber": ""
    },
    "ShipTo": {
      "DefaultSt": "",
      "FirstName": "",
      "LastName": "",
      "Company": "",
      "AddressOne": "",
      "AddressTwo": "",
      "Locality": "",
      "AdministrativeArea": "",
      "PostalCode": "",
      "Country": "",
      "Email": "",
      "PhoneNumber": "",
      "ShippingAddressTokenId": ""
    },
    "PaymentInstrument": {
      "PaymentInstrumentTokenId": ""
    },
    "CustomerPaymentInstrument": {
      "CustomerPaymentInstrumentTokenId": "",
      "DefaultCpi": ""
    },
    "PayerAuthentication": {
      "Step": "",
      "UrlCommerce": "",
      "ReferenceId": ""
    }
  };
}


  
if (this.idFormaPago==2){
  datos={
   "MessageTypeId": "0200",
   "ProcessingCode": "000000",
   "SystemsTraceNo": _systemtraceno+"",
   "TimeLocalTrans": "",
   "DateLocalTrans": "",
   "PosEntryMode": "012",
   "Nii": "003",
   "PosConditionCode": "00",
   "AdditionalData": "VC"+_cuotas+"",
   "OrderInformation": "",
   "FormatId": "1",
   "Merchant": {
     "TerminalId": this.terminalNeoNetDTO,
     "CardAcqId": this.afiliacionNeoNetDTO
   },
   "Card": {
     "Type": _cardType,
     "PrimaryAcctNum": _tarjeta,
     "DateExpiration":_vencimientoNeo,
     "Cvv2": _cvv,
     "Track2Data": "",
     "CardTokenId": "",
     "UniqueCodeofBeneciary": ""
   },
   "Amount": {
     "AmountTrans": _totalNeo,
     "AmountDiscount": "",
     "RateDiscount": "",
     "AdditionalAmounts": "",
     "TaxDetail": [
     ]
   },
   "PrivateUse60": {
     "BatchNumber": ""
   },
   "PrivateUse63": {
     "LodgingFolioNumber14": "",
     "NationalCard25": "",
     "HostReferenceData31": "",
     "TaxAmount1": ""
   },
   "TokenManagement": {
     "Type": "",
     "ActionMethod": ""
   },
   "Customer": {
     "CustomerTokenId": "",
     "FirstName": "",
     "LastName": "",
     "TaxId": "",
     "IdentificationType": "",
     "PersonalId": "",
     "Email": "",
     "PhoneNumber": ""
   },
   "BillTo": {
     "FirstName": "",
     "LastName": "",
     "Company": "",
     "AddressOne": "",
     "AddressTwo": "",
     "Locality": "",
     "AdministrativeArea": "",
     "PostalCode": "",
     "Country": "",
     "Email": "",
     "PhoneNumber": ""
   },
   "ShipTo": {
     "DefaultSt": "",
     "FirstName": "",
     "LastName": "",
     "Company": "",
     "AddressOne": "",
     "AddressTwo": "",
     "Locality": "",
     "AdministrativeArea": "",
     "PostalCode": "",
     "Country": "",
     "Email": "",
     "PhoneNumber": "",
     "ShippingAddressTokenId": ""
   },
   "PaymentInstrument": {
     "PaymentInstrumentTokenId": ""
   },
   "CustomerPaymentInstrument": {
     "CustomerPaymentInstrumentTokenId": "",
     "DefaultCpi": ""
   },
   "PayerAuthentication": {
     "Step": "",
     "UrlCommerce": "",
     "ReferenceId": ""
   }
 };
}



  
  let json = JSON.stringify(datos);
  let data=JSON.parse(json.toString());

//let contadorTiempo:number=0;
let responseCode:string="";

//inicio tiempo

// const timer = setInterval(() => {
// console.log(contadorTiempo);
//   if (contadorTiempo==1){
  

    this.neoLinkService.pagarNeoLink( data,this.merchantUserDTO,this.merchantPasswordDTO,this.ipPublicaDTO,_systemtraceno,this.terminalNeoNetDTO,this.afiliacionNeoNetDTO,_tarjeta,_vencimientoNeo,_cvv,_totalNeo,_cardType,this.numeroPedido,this.OnCambiarFormatoTajeta(_tarjeta),this.formCarrito.value['txtNombreTarjeta'].toString().toUpperCase() ,this.granTotalDTO,_cuotas).subscribe(response =>{
     console.log(response)
      
 
    let jsonstring = JSON.stringify(response);
    let dataNeo=JSON.parse(jsonstring+"");
  
    let authResponse;
    let retrievalReponse;
    let messageTypeId;

    Object.keys(dataNeo).forEach(key => {

    if (`${key}`=='ResponseCode'){
   
      responseCode=`${dataNeo[key]}`;
    }

    if (`${key}`=='AuthIdResponse'){
   
      authResponse=`${dataNeo[key]}`;
    }

    if (`${key}`=='RetrievalRefNo'){
   
      retrievalReponse=`${dataNeo[key]}`;
    }

    if (`${key}`=='MessageTypeId'){
      messageTypeId=`${dataNeo[key]}`;
    }

  
});



if (responseCode!==null && responseCode=='00' && messageTypeId=='0210'){
 // contadorTiempo=0;
 // clearInterval(timer);
//  this.OnActualizarPagoTarjeta(this.numeroPedido,this.OnCambiarFormatoTajeta(_tarjeta),_systemtraceno,authResponse,retrievalReponse,this.formCarrito.value['txtNombreTarjeta']);
 this.OnGetDatosPagoPedido();
    this.esperar=false;
    this.respuestaModal=true ;
  this.respuestaModalTarjeta=true ;

 
}else {
 
  this.formCarrito.controls['txtTarjeta'].setValue("");
  this.formCarrito.controls['txtCodigoSeguridad'].setValue("");
  this.formCarrito.controls['txtVencimiento'].setValue("");
  this.formCarrito.controls['txtNombreTarjeta'].setValue("");

  this.esperar=false;
  this.mensajeForm="No fue posible terminar la transacción.";
  $(this.myModal.nativeElement).modal('hide'); 
  $(this.myModalError.nativeElement).modal('show');
  //contadorTiempo=0;
  //clearInterval(timer);


  
}











   });




  //} // fin si contador==1

// if (contadorTiempo==10 && responseCode=="" ){
  
//   clearInterval(timer);
//   contadorTiempo=0;

//   this.GenerarReversionNeoNet(_tarjeta,_vencimientoNeo,_cvv,_totalNeo,_cardType);


// }

//   contadorTiempo++;

  

//   }, 1000); //fin tiempo



}


 valid_credit_card(value:any) {
  // accept only digits, dashes or spaces
      if (/[^0-9-\s]+/.test(value)) return false;
  
  // The Luhn Algorithm. It's so pretty.
      var nCheck = 0, nDigit = 0, bEven = false;
      value = value.replace(/\D/g, "");
  
      for (var n = value.length - 1; n >= 0; n--) {
          var cDigit = value.charAt(n),
              nDigit = parseInt(cDigit, 10);
  
          if (bEven) {
              if ((nDigit *= 2) > 9) nDigit -= 9;
          }
  
          nCheck += nDigit;
          bEven = !bEven;
      }
  
      return (nCheck % 10) == 0;
  }



LeerJsonString(cadena:string,indice:number ){
//  let jsonNeo = JSON.stringify(response);
 // let dataNeo=JSON.parse(jsonNeo);
 // let keys = Object.keys(dataNeo); 


  let json = JSON.stringify(cadena);
  let datos=JSON.parse(json);
  let clave = Object.keys(datos); 
 let keyOut = clave[indice];
// let keyReponse = keys[9];
return  datos[keyOut]
}


logout(){
  localStorage.removeItem('shopping');
  this.tokenStorage.signOut();
 
  localStorage.removeItem('cliente_stg');
  localStorage.removeItem('Respuesta_Neo_Net');
  this.router.navigateByUrl('/inicio');
}


ValidarFechaTarjeta(fechaTarjeta:String) {

  let rs:boolean=false 

let MesTarjeta=fechaTarjeta.substring(0,2);


let AnioTarjeta=fechaTarjeta.substring(2,4);

  let fecha = new Date();

  let mesActual=fecha.getMonth()+1;



  let anioActual=fecha.getFullYear().toString().substring(2,4);
  
  if (Number(AnioTarjeta)>Number(anioActual)){
  rs=true ;

  }else {

    if (   ( Number(AnioTarjeta)==Number(anioActual)) && (  ( Number(MesTarjeta)>=Number(mesActual)  )   ) ){
      rs=true;
    }


  }
  
  return rs;

}


GuardarPedido(){




  let  cadenaDetallePedido:string=this.tempdetallepedido.replace("/", " ");

if ( (parseInt(this.formCarrito.value['cmbFormaPago'])==1)||(parseInt(this.formCarrito.value['cmbFormaPago'])==2) )        {

  

  let tarjeta=  this.formCarrito.value['txtTarjeta'];
  tarjeta=tarjeta.substr(-4);
  
  this.pedidoService.nuevoPedido(
  this.idUsrDTO,
  this.formCarrito.value['cmbDepto'],
  this.formCarrito.value['cmbMuni'],
  this.granTotalDTO,
  this.formCarrito.value['txtRecibe'].toString().toUpperCase() ,
  this.formCarrito.value['txtDireccion'].toString().toUpperCase(),
  this.formCarrito.value['txtTelefono'],
  this.formCarrito.value['cmbFormaPago'],
  cadenaDetallePedido,
  "NINGUNO", 
  "0000",
  "000",
  this.formCarrito.value['txtNit'].toString().toUpperCase(),
  this.formCarrito.value['txtNombreContribuyente'].toString().toUpperCase(),
  this.formCarrito.value['txtDireccionContribuyente'].toString().toUpperCase(),
  "0",
  this.formCarrito.value['txtTelFactura'].toString(),
  this.formCarrito.value['txtNombreTarjeta'].toString().toUpperCase(),
this.idCodigoDescuentoDTO).subscribe(response =>{
    console.log(response)
    if (response.toString()!=="0"){
      this.numeroPedido=response+"";
     
     
    this.GenerarPagoNeoLink(this.formCarrito.value['txtTarjeta'],this.formCarrito.value['txtVencimiento'],this.formCarrito.value['txtCodigoSeguridad'],  this.granTotalDTO,this.numeroPedido,this.formCarrito.value['cmbCuotas'])
    }
 
  })

}
  
     
if ( parseInt(this.formCarrito.value['cmbFormaPago']) ==3 ) {

  


      this.pedidoService.nuevoPedido(
        this.idUsrDTO,
        this.formCarrito.value['cmbDepto'],
        this.formCarrito.value['cmbMuni'],
        this.granTotalDTO,
        this.formCarrito.value['txtRecibe'].toString().toUpperCase() ,
        this.formCarrito.value['txtDireccion'].toString().toUpperCase(),
        this.formCarrito.value['txtTelefono'],
        this.formCarrito.value['cmbFormaPago'],
        cadenaDetallePedido,
        "XXX-XXXX-XXXX-XXXX", 
        "XX-XX",
        "XXX",
        this.formCarrito.value['txtNit'].toString().toUpperCase(),
        this.formCarrito.value['txtNombreContribuyente'].toString().toUpperCase(),
        this.formCarrito.value['txtDireccionContribuyente'].toString().toUpperCase(),
        "0",
        this.formCarrito.value['txtTelFactura'].toString(),
        "NINGUNO",
        this.idCodigoDescuentoDTO).subscribe(response =>{
          console.log(response)
          if (response.toString()!=="0"){
            localStorage.setItem('countPedido', "0");
            localStorage.removeItem('shopping');
            this.numeroPedido=response.toString();
           
            
            this.esperar=false;
            this.respuestaModal=true;
            this.respuestaModalTarjeta=false;
            this.LimparBD();
          }
          if (response.toString()=="0"){
            this.esperar=false;
            this.respuestaModal=false;
            this.respuestaModalTarjeta=false;
            $(this.myModal.nativeElement).modal('hide'); 
           }
        })

  
      }

}



OnCambiarFormatoTajeta(tarjeta:any){
  let ulimosdigitos = tarjeta.slice(12, 16);
  let nuevacadena="XXXX XXXX XXXX " + ulimosdigitos
return nuevacadena
}

 zfill(number:number, width:number) {
  var numberOutput = Math.abs(number); /* Valor absoluto del número */
  var length = number.toString().length; /* Largo del número */ 
  var zero = "0"; /* String de cero */  
  
  if (width <= length) {
      if (number < 0) {
           return ("-" + numberOutput.toString()); 
      } else {
           return numberOutput.toString(); 
      }
  } else {
      if (number < 0) {
          return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
      } else {
          return ((zero.repeat(width - length)) + numberOutput.toString()); 
      }
  }
}

OnSelectProducto02(_idproducto:any){

  this.router.navigate(['/pedido', _idproducto,0,0,0,0,0])

  .then(() => {
    window.location.reload();
  });


  

}


GenerarCambio(){



  if (this.tokenStorage.getToken()==null) {
    
    this.router.navigateByUrl('/login-cliente');
  }else {



  if ( this.ValidarNuevoCambio()==0){



  if (this.activaPago==1){

             if ( this.ValidarNuevoRegistro2()==0){

              this.GuardarCambio();
            }else
             { 
              this.mytxtTarjeta.nativeElement.focus();
            }

  }

  if (this.activaPago==0){
 if ( this.ValidarNuevoRegistro()==0){
  this.formCarrito.value['txtTarjeta']="0";
  this.formCarrito.value['txtNit']="NULO";
  this.formCarrito.value['txtNombreContribuyente']="NULO";
  this.formCarrito.value['txtDireccionContribuyente']="NULO";
  this.GuardarCambio();

 }else {
  this.mycmbDepto.nativeElement.focus();
 }

  }

  //  switch ( parseInt(this.formCarrito.value['cmbFormaPago']) ) {
  //    case 1:
  //      if ( this.ValidarNuevoRegistro2()==0){

  //        this.GuardarPedido();
  //      }else { this.mytxtTarjeta.nativeElement.focus();}

  //    break;
  //    case 2:


  //    if ( this.ValidarNuevoRegistro3()==0){
  //      this.GuardarPedido();

  //    }




  //    break;  
   //}



   }else {


   //  alert("Falta complementar datos para el ENVIO");
     this.mycmbDepto.nativeElement.focus();
   }







  }


}




VerificarSesion(){


  if (this.tokenStorage.getToken()==null) {

 
    localStorage.removeItem('shopping');
    localStorage.setItem('ejecutaCompra','0');
    const lista: Shopping= {
    depto: this.formCarrito.value['cmbDepto'],
    muni:this.formCarrito.value['cmbMuni'],
    granTotal:  this.granTotalDTO,
    recibe:   this.formCarrito.value['txtRecibe'].toString().toUpperCase(),
    direccion: this.formCarrito.value['txtDireccion'].toString().toUpperCase(),
    telefono:   this.formCarrito.value['txtTelefono'],
    formaPago: this.formCarrito.value['cmbFormaPago'],
    cuotas: this.formCarrito.value['cmbCuotas'],
    tarjeta: this.formCarrito.value['txtTarjeta'],
    nit:this.formCarrito.value['txtNit'],
    nombreFactura:this.formCarrito.value['txtNombreContribuyente'],
    direccionFactura:this.formCarrito.value['txtDireccionContribuyente'],
    telefonoFactura:this.formCarrito.value['txtTelFactura'],
    vencimiento:this.formCarrito.value['txtVencimiento'],
    cvv:this.formCarrito.value['txtCodigoSeguridad'],
    nombreTarjeta:this.formCarrito.value['txtNombreTarjeta'],
   }

  this.shopping.push(lista);
  localStorage.setItem('shopping',JSON.stringify( this.shopping))


    this.router.navigateByUrl('/login-cliente/1');
   }
  else 
  {
 

    switch ( parseInt(this.formCarrito.value['cmbFormaPago']) ) {
      case 1:
   
        this.ActualizarExistencia();
        
        this.OnVerificarLimiteExistencia(this.idUsrDTO,this.tempdetallepedido.toString());
       
      break;

      case 2:
       
        this.ActualizarExistencia();
        this.OnVerificarLimiteExistencia(this.idUsrDTO,this.tempdetallepedido.toString());
      break;

      case 3:

      this.ActualizarExistencia();
        this.OnVerificarLimiteExistencia(this.idUsrDTO,this.tempdetallepedido.toString());

    }





   }
}



ActualizarExistencia(){


  for (let lista of this.pedidoTemp){
    this.stockERPService.getStockERP(lista.codigoErp).subscribe(response =>{
      if (response.length>0){

        for (let existe of response){
          this.OnGuardarStockTemporal(existe.codigoErp,existe.existencia);
        }

      }
    });

  }


}





GenerarPedido(){



   if ( this.ValidarNuevoRegistro()==0){

    this.OnGetCredencialNeoNet();


  
    switch ( parseInt(this.formCarrito.value['cmbFormaPago']) ) {
      case 1:
    
      if ( this.ValidarNuevoRegistro2()==0){
      
        let tarjetaAceptada:boolean=false;
        let vencimientoAceptado:boolean=false;
      
      tarjetaAceptada=  this.valid_credit_card(this.formCarrito.value['txtTarjeta']);
      vencimientoAceptado=this.ValidarFechaTarjeta(this.formCarrito.value['txtVencimiento']);

       if (tarjetaAceptada==true  ){

          if (vencimientoAceptado==true){
            this.tarjetaInvalida=false;
            this.fechaTarjetaInvalida=false;
            this.VerificarSesion();
          }else {
            this.fechaTarjetaInvalida=true;
          }


      
       
       }else {
        this.tarjetaInvalida=true;
       }

   

    
      }else 
        { 
          this.mytxtTarjeta.nativeElement.focus();
        }
      break;

      case 2:

      
      if ( this.ValidarNuevoRegistro2()==0){
      
        let tarjetaAceptada:boolean=false;
        let vencimientoAceptado:boolean=false;
      
      tarjetaAceptada=  this.valid_credit_card(this.formCarrito.value['txtTarjeta']);
      vencimientoAceptado=this.ValidarFechaTarjeta(this.formCarrito.value['txtVencimiento']);

       if (tarjetaAceptada==true  ){

          if (vencimientoAceptado==true){
            this.tarjetaInvalida=false;
            this.fechaTarjetaInvalida=false;
            this.VerificarSesion();
          }else {
            this.fechaTarjetaInvalida=true;
          }


      
       
       }else {
        this.tarjetaInvalida=true;
       }

   

    
      }else 
        { 
          this.mytxtTarjeta.nativeElement.focus();
        }




      break;


      case 3:
      if ( this.ValidarNuevoRegistro3()==0){
        this.VerificarSesion();
        
   
      }
      break;  
    }

    }else 
    {
      this.mycmbDepto.nativeElement.focus();
    }

}



OnCalcularDescuento(descuentoPorcentaje:any,idCodigo:any){

localStorage.setItem('codigoDescuentoId', idCodigo);
 

  if (Number(descuentoPorcentaje)>0){
    
    this.noExisteCodigoDescuento=false;
    this.idCodigoDescuentoDTO=idCodigo;
 

  //  this.OnCargarDetalle().then(rs => {
  //    this.pedidoTemp = rs;
  
      for (let listaActual of this.pedidoTemp){

        const listaNueva: PedidoTemp= {
          id:listaActual.id,
          indiceDetallePedido:listaActual.indiceDetallePedido,
          idPedido:listaActual.idPedido,
          idProducto:listaActual.idProducto,
          modelo:listaActual.modelo+"",
          descripcion:listaActual.descripcion+"",
          color:listaActual.color+"",
          talla:listaActual.talla+"",
          cantidad:listaActual.cantidad,
         precio:listaActual.precio,
          descuento:descuentoPorcentaje,
          precioFinal: Number(listaActual.precioFinal)-(Number(listaActual.precioFinal)* (Number(descuentoPorcentaje)/100)) ,
          importe:Number(listaActual.precioFinal)-(Number(listaActual.precioFinal)* (Number(descuentoPorcentaje)/100)),
          imagen: listaActual.imagen,
          idColor:listaActual.idColor,
          idTalla:listaActual.idTalla,
          idProductoAnterior: listaActual.idProductoAnterior,
          colorErp:listaActual.colorErp,
          colorIdErp:listaActual.colorIdErp,
          tallaErp:listaActual.tallaErp,
          codigoErp:listaActual.codigoErp,
          limitarExistencia:listaActual.limitarExistencia,
          msgDisponibilidad:listaActual.msgDisponibilidad
         
        }

        this.ModificarDeCarrito(listaNueva);
       
  //  let json = JSON.stringify(listaNueva);

   // let nuevodata=JSON.parse(json.toString());
   // this.LimparBD();
    // this.AgregarACarrito(nuevodata);

      }


      

    

  
  //  });












  }else {

    this.noExisteCodigoDescuento=true;
  }


this.MostrarDetalle();

}



OnGetCodigoDescuentoAll(){

  this.productoDTOService.getCodigoDescuentoAll(  ).subscribe(response =>{

    if (response.length>0){
      
      this.SIExistenCodigoDescuento=true ;
 
    
    }else {
    
      this.SIExistenCodigoDescuento=false ;
    }
    
    
    }
    
    );
    

}


OnGetCodigoDescuento(){



this.productoDTOService.getCodigoDescuento(  this.formCarrito.value['txtCodigoDescuento']).subscribe(response =>{

if (response.length>0){
  

  for(let dato of response) {

  

    this.OnCalcularDescuento(dato.valorDescuento,dato.idCodigoDescuento);
   
  }


}else {
  this.OnCalcularDescuento(0,0);
  
}


}

);



}



  OnVerificarLimiteExistencia(idUsuario:number,detallePedido:string) {


//console.log(this.tempdetallepedido.toString());
      //  let cadenaDetallePedido:string=this.tempdetallepedido.toString();
      let  cadenaDetallePedido:string=detallePedido.replace("/", " ");



     this.productoDTOService.verificarLimiteExistencia(idUsuario,cadenaDetallePedido).subscribe(response =>{
      if (response.toString()=="0"){
        this.resultadoVerificacion=[];
        this.esperar=true;
        $(this.myModal.nativeElement).modal('show'); 

        this.GuardarPedido();

      }else {
        let json = JSON.stringify(response);
      let data=JSON.parse(json);
        this.resultadoVerificacion=data;
        this.esperar=false ;
        $(this.myModal.nativeElement).modal('hide'); 
         $(this.myModal2.nativeElement).modal('show'); 

      }

    
    
    })
  
   
}



OnHabilitarFormaPago(){

this.idFormaPago=parseInt(this.formCarrito.value['cmbFormaPago']);

  switch ( parseInt(this.formCarrito.value['cmbFormaPago']) ) {
    case 1:
      this.formCarrito.controls['cmbCuotas'].setValue("00")
   // this.idFormaPago=1;
    this.formCarrito.controls['txtTarjeta'].setValue("");
    this.formCarrito.controls['txtVencimiento'].setValue("");
    this.formCarrito.controls['txtCodigoSeguridad'].setValue("");
    this.formCarrito.controls['txtNombreTarjeta'].setValue("");
    break;
    case 2:
      this.formCarrito.controls['cmbCuotas'].setValue("02")
      // this.idFormaPago=1;
       this.formCarrito.controls['txtTarjeta'].setValue("");
       this.formCarrito.controls['txtVencimiento'].setValue("");
       this.formCarrito.controls['txtCodigoSeguridad'].setValue("");
       this.formCarrito.controls['txtNombreTarjeta'].setValue("");
 

       break;
    case 3:
    //  this.idFormaPago=2;
      this.formCarrito.controls['txtTarjeta'].setValue("0000000000000000");
      this.formCarrito.controls['txtVencimiento'].setValue("0000");
      this.formCarrito.controls['txtCodigoSeguridad'].setValue("000");
      this.formCarrito.controls['cmbCuotas'].setValue("00");
      this.formCarrito.controls['txtNombreTarjeta'].setValue("");
    break;  
  }




}

OnBuscarAll(){
  this.modoBusqueda=true;
  this.currentPage=0;
  this.content=[];

this.CargarPorDescripcionPg();

  }


  CargarPorDescripcionPg(){
        

    this.productoDTOService.getProductosDTOByDescripcionPg(this.currentPage, this.size, this.order, this.asc,0,this.formBuscar.value['txtBuscar']).subscribe(
      data => {
        this.content.push(...data.content);
       // this.isFirst = data.first;
       // this.isLast = data.last;
      //  this.totalPages = new Array(data['totalPages']);
      this.totalPages=data.totalPages;
        console.log(data);
      },
      err => {
        console.log(err.error);
      }
    );

  }


  onScroll(){
    if(this.modoBusqueda==false){
      //this.currentPage++;
     // this.cargarProductoPg();
    }else{
      this.currentPage++;
      this.CargarPorDescripcionPg();
    }

   
  }

   
}